var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"safety-headings wrapper mx-auto px-3 md:px-8 xl:px-0"},[_c('h3',[_vm._v(_vm._s(_vm.content.title))]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.content.body.content[0].content[0].value))])])}
var staticRenderFns = []

export { render, staticRenderFns }